import { brand } from "config/brand"
import { journeys } from "config/journeys"
import * as React from "react"
import Document from "components/Document"
import Footer from "components/Footer"
import JourneyCategoryPage from "components/start/JourneyCategoryPage"
import JourneyPageLink from "components/start/JourneyPageLink"
import Navbar from "components/Navbar"
import SideNav from "components/SideNav"
import PageWrapper, { PaddingTop } from "components/PageWrapper"
import imgPurchasingAHomeLandscape from "images/start/purchasing-a-home-landscape.jpg"

const StartPurchase: React.FC = () => {
  return (
    <Document
      title="Start your Home-buying Journey"
      description={`Get started on your home-buying journey with ${brand.name}.`}
      thumbnail={imgPurchasingAHomeLandscape}
      pageClass="bet-StaticPage"
      pageId="startPage"
      brandMetaPrefix={true}
    >
      <Navbar />
      <SideNav />
      <PageWrapper paddingTop={PaddingTop.Navbar}>
        <JourneyCategoryPage category={journeys.purchase}>
          <JourneyPageLink
            journey={journeys.purchase.pages["thinking-of-buying"]}
            urlPrefix="/start/"
            key="1"
            journeySlug="thinking-of-buying"
          />
          <JourneyPageLink
            journey={journeys.purchase.pages["shopping-for-a-home"]}
            urlPrefix="/start/"
            key="2"
            journeySlug="shopping-for-a-home"
          />
          <JourneyPageLink
            journey={journeys.purchase.pages["found-a-property"]}
            urlPrefix="/start/"
            key="3"
            journeySlug="found-a-property"
          />
        </JourneyCategoryPage>
        <Footer loanType="purchase" />
      </PageWrapper>
    </Document>
  )
}

export default StartPurchase
